/**
 * Painel direito — polimórfico: uma ficha por tipo de item.
 *
 * É este polimorfismo que impede 5 papéis de virarem 5 telas. A coluna esquerda
 * é agnóstica (rótulo + ícone + meta); adicionar papel adiciona no máximo UMA
 * ficha aqui, nunca uma tela nova.
 *
 * O painel só existe quando há item em foco COM ficha — sem isso a coluna de
 * resultados toma a paleta inteira. A paleta cresce da esquerda para a direita,
 * nunca nasce com metade vazia (estado 1 da peça 03 da rodada de design).
 */
import { PersonHitCard } from '../persons/PersonHitCard';

import { OperatorHitCard } from './OperatorHitCard';

import type { SpotlightPreviewRef } from './types';

export function SpotlightPreview({ previewRef }: { previewRef: SpotlightPreviewRef }): JSX.Element {
  return (
    <div className="spotlight__preview" data-testid="spotlight-preview">
      {previewRef.kind === 'person' && (
        <PersonHitCard person={previewRef.person} collapsible={false} />
      )}
      {previewRef.kind === 'operator' && <OperatorHitCard userId={previewRef.userId} />}
    </div>
  );
}
